/* ../lib/components/App.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	append,
	create_component,
	destroy_component,
	element,
	init,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import Router from "svelte-spa-router";
import routes from "./routes";

function add_css() {
	var style = element("style");
	style.id = "svelte-1d000bc-style";
	style.textContent = "body{background-color:#eee}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let current;
	const router = new Router({ props: { routes } });

	return {
		c() {
			create_component(router.$$.fragment);
		},
		m(target, anchor) {
			mount_component(router, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(router.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(router.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(router, detaching);
		}
	};
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1d000bc-style")) add_css();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default App;